.notes {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 24px;
}

.note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  font-size: 13px;
  color: var(--muted);
  line-height: 1.55;
}

.noteIcon {
  color: var(--muted2);
  flex-shrink: 0;
  margin-top: 1px;
}

.block {
  margin-bottom: 4px;
}

.blockLabel {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 4px;
}

.blockHint {
  font-size: 13.5px;
  color: var(--muted);
  margin-bottom: 14px;
  line-height: 1.5;
}

/* Three-way mode toggle */
.modeRow {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.modeBtn {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  background: white;
  color: var(--muted);
  border: 1.5px solid var(--border);
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: border-color .15s, background .15s, color .15s;
}

.modeBtn:hover {
  border-color: var(--blue);
  color: var(--blue);
  background: var(--blue-lt);
}

.modeBtnActive {
  background: var(--blue);
  color: white;
  border-color: var(--blue);
}

.modeBtnActive:hover {
  background: var(--blue-dk);
  color: white;
  border-color: var(--blue-dk);
}

.inputWrap {
  margin-top: 4px;
}

.emptyWarning {
  font-size: 13px;
  color: var(--yellow);
  font-weight: 500;
  margin-top: 6px;
}

.modeHint {
  font-size: 12.5px;
  color: var(--muted2);
  margin-top: 8px;
  line-height: 1.55;
}

.divider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 24px 0;
}

/* Fixed-tier multi-select pills (size filter) */
.tierRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tierPill {
  display: inline-flex;
  align-items: center;
  padding: 7px 16px;
  background: white;
  color: var(--muted);
  border: 1.5px solid var(--border);
  border-radius: 20px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  transition: border-color .15s, background .15s, color .15s;
}

.tierPill:hover {
  border-color: var(--blue);
  color: var(--blue);
  background: var(--blue-lt);
}

.tierPillOn {
  background: var(--blue);
  color: white;
  border-color: var(--blue);
}

.tierPillOn:hover {
  background: var(--blue-dk);
  color: white;
  border-color: var(--blue-dk);
}
